import BasePerimeter from '@/kindergarten/perimeters/BasePerimiter';

export default new BasePerimeter({
  purpose: 'internal_role',

  can: {
    route() {
      return this.child && this.isInternal();
    },
  },
});



// WEBPACK FOOTER //
// ./src/kindergarten/perimeters/InternalPerimeter.js